import LoLExaminationRoom from './LoLExaminationRoom';

export default LoLExaminationRoom;
